import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { handleUserError } from '../../../utils/error';
import userRequest from '../../../utils/userRequest';
import camera from "../../../images/camera.png";
import CloseIcon from '@mui/icons-material/Close';
import { BeatLoader } from 'react-spinners';
import ViewportMeta from '../../../utils/ViewportMeta';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import Sidebarfats from '../../../components/sidebar/Sidebarfats';
import CustomSnakebar from '../../../utils/CustomSnakebar';
const AssetVerification = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation()
  const formRef = useRef(null);
  const [file, setFile] = useState([]);
  const [dataFound, setDataFound] = useState(true);
  //error uff
  const [data, setData] = useState([]);
  const [area, setArea] = useState('');
  const [locationTag, setlocationTag] = useState('');
  const [serial, setSerial] = useState('');
  const [employee, setEmployee] = useState('');
  const [Business, setBusiness] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [employeesList, setEmployeesList] = useState([]);
  const [phone, setPhone] = useState('');
  const [assetcondition, setAssetcondition] = useState([]);
  const [Bought, setBought] = useState([]);
  const [tagNumber, setTagNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [employeeId, setEmployeeId] = useState('');
  const [message, setMessage] = useState(null)
  const [error, setError] = useState(null)


  const handleTagNumberChange = (event) => {
    const tagNumber = event.target.value;
    console.log(tagNumber);

    const data = {
      TagNumber: tagNumber,
    };
    userRequest.post("/GetAssetMasterEncodeAssetCaptureById", data)
      .then(response => {
        console.log(response?.data?.recordset[0]);
        let data = response?.data?.recordset[0];
        setData(data);
        setBusiness(data.BusinessUnit);
        setArea(` ${data.DaoName}  -  ${data.BusinessUnit} \n ${data.buildingAddress} \n ${data.BUILDINGNO} - ${data.FLOORNO}`);
      })
      .catch(error => {
        handleUserError(error)
        console.error(error);
      });
  };
  // useEffect(() => {
  //   setDataFound(true);
  // }, [data]);

  useEffect(() => {
    userRequest.get("/GetAllAssetCondition")
      .then(response => {
        console.log(response.data);
        setAssetcondition(response.data);
      })
      .catch(error => {
        handleUserError(error)
        console.error(error);
      });
    userRequest.get("/GetAllAssetConditionBought")
      .then(response => {
        console.log(response.data);
        setBought(response.data);
      })
      .catch(error => {
        handleUserError(error)
        console.error(error);
      });
    userRequest.get("/GetAllEmployeeList").then(response => {
      console.log(response.data);
      setEmployeesList(response.data ?? []);
    })
      .catch(error => {
        handleUserError(error)
        console.error(error);
      });
  }, []);




  // const handleFileUpload = (event) => {
  //   const selectedFiles = event.target.files;
  //   const filesArray = Array.from(selectedFiles).slice(0, 4); // Limit to 4 files
  //   setFile(filesArray);
  //   if (filesArray.length >= 4) {
  //     event.target.disabled = true; // Disable file input after 4 files
  //   }
  // };

  const handleFileUpload = (event) => {
    const selectedFiles = event.target.files;
    const MAX_IMAGES = 4;

    const filesArray = Array.from(selectedFiles).slice(0, 4); // Limit to 4 files

    // set file to previou file and new file but not more than 4
    setFile(prevFile => {
      const newFile = [...prevFile, ...filesArray];
      // check if total number of images exceeds the limit
      if (newFile.length > MAX_IMAGES) {
        // remove excess images
        return newFile.slice(0, MAX_IMAGES);
      }
      return newFile;
    });

    if (file.length + filesArray.length >= 4) {
    }
  };

  const handleImageClick = () => {
    const fileInput = document.getElementById('fileInput');
    fileInput.click();
  };
  useEffect(() => {
    setDataFound(true);
  }, [tagNumber])

  const handleTagSerch = () => {
    if (tagNumber.length > 0) {
      console.log(tagNumber);
      const data = {
        TagNumber: tagNumber,
      };
      userRequest.post("/GetAssetMasterEncodeAssetCaptureById", data)
        .then(response => {
          // console.log(response?.data?.recordset[0]);
          let data = response?.data?.recordset[0];
          setData(data);
          // setlocationTag(data.LocationTag);
          // setSerial(data.sERIALnUMBER);
          // setEmployee(data.EMPLOYEEID);
          setBusiness(data.BusinessUnit);
          // setPhone(data.PhoneExtNo);
          // setBought(data.Bought);
          setArea(` ${data.DaoName}  -  ${data.BusinessUnit} \n ${data.buildingAddress} \n ${data.BUILDINGNO} - ${data.FLOORNO}`);
          setData(prevData => ({
            ...prevData,
            // get location tag value from input name LocationTag
            LocationTag: locationTag,
            sERIALnUMBER: data.sERIALnUMBER,
            BusinessUnit: data.BusinessUnit,
            PhoneExtNo: data.PhoneExtNo,
            Bought: data.Bought,
            FullLocationDetails: `${data.DaoName}-${data.BusinessUnit}, ${data.buildingAddress}, ${data.BUILDINGNO}-${data.FLOORNO}`,
          }));
          setDataFound(true);
          console.log(data);

        })
        .catch(error => {
          setArea('');
          setDataFound(false);
          setData([])
          handleUserError(error)
          console.error(error);
        });
    }
    else {
      setDataFound(true);
      setData([])
    }
  }

  const handleInputChanges = (event) => {
    if (event.target.name === 'LocationTag') {
      setlocationTag(event.target.value);
    }

    if (event.target.name === 'TagNumber') {
      setTagNumber(event.target.value);
    }


    if (event.target.name === 'EMPLOYEEID') {
      const EmpID = event.target.value;
      const data = {
        EmpID: EmpID,
      };
      userRequest.post("/getEmployeeListById", data)
        .then(response => {
          let data = response?.data?.recordset[0];
          console.log(response.data)
          setEmployeeName(data.EmpName)
        })
        .catch(error => {
          handleUserError(error)
          console.error(error);
        });
    }
    event.preventDefault();
    setData((prev) => ({
      ...prev,
      [event.target.name]: event.target.value
    }))
    console.log(data);

  }

  const handleRemoveImage = (index) => {
    const newFiles = file.filter((_, i) => i !== index);

    setFile(newFiles);
    document.getElementById('fileInput').disabled = false;
  }

  const handleForm = (e) => {

    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData();
    if (file.length > 0) {
      file.forEach((file, index) => {
        formData.append(`images`, file);
      })
    }
    data.EMPLOYEEID = employeeId;
    Object.entries(data).forEach(([key, value]) => {
      console.log(key, value);
      if (key !== "MainSubSeriesNo") {
        formData.append(key, value);
      }

    });
    // formData.append("EMPLOYEEID", employeeId);

    userRequest.post("/PostAssetMasterEncodeAssetCaptureFinal", formData)
      .then(response => {
        userRequest.delete(`/DeleteAssetMasterEncodeAssetCaptureById/${encodeURIComponent(data.TagNumber)}`)
          .then(response => {
            console.log(response);
            // handle the API response
            setIsLoading(false);
            console.log(response?.data);
            // empty all the field
            const locationTagInput = document.getElementById("locationtag");
            const locationTagValue = locationTagInput.value;
            formRef.current.reset();
            locationTagInput.value = locationTagValue;
            setFile([]);
            setData({});
            setlocationTag('');
            setSerial('');
            setEmployee('');
            setBusiness('');
            setPhone('');
            // setBought([]);

            setArea('');
            setEmployeeName('');


          }).catch(error => {
            handleUserError(error)
            console.error(error);
          });
        setMessage('Asset has been verified succesfully')


      })
      .catch(error => {
        // handle the API error
        setIsLoading(false);
        console.error(error);
        handleUserError(error)
        setError("ASSET has been not verified")
      });
  }

  const resetSnakeBarMessages = () => {
    setError(null)
    setMessage(null)
  }


  // const defaultProps = {
  //   options: employeesList,
  //   getOptionLabel: (option) => option.EmpName,
  // };
  const defaultProps = {
    options: employeesList,
    getOptionLabel: (option) => `${option.EmpName} (${option.EmpID})`,
  };
  const flatProps = {
    options: employeesList.map((option) => option.EmpName),
  };
  return (
    <>
      <div className={`p-0 h-full ${i18n.language === 'ar' ? 'sm:mr-72' : 'sm:ml-72'}`}  >
        {message && (
          <CustomSnakebar
            message={message}
            severity="success"
            onClose={resetSnakeBarMessages}
          />
        )}
        {error && (
          <CustomSnakebar
            message={error}
            severity="error"
            onClose={resetSnakeBarMessages}
          />
        )}
        <ViewportMeta />
        {isLoading &&
          <div className='loading-spinner-background'
            style={{
              zIndex: 9999, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.5)',
              display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed'


            }}
          >
            <BeatLoader
              size={18}
              color={"#6439ff"}
              // height={4}
              loading={isLoading}
            />
          </div>
        }


        <div className={`z-10 before:animate-pulse my-7 smm:my-10 before:bg-gradient-to-b before:from-gray-900 overflow-hidden before:via-[#00FF00] before:to-gray-900 ${i18n.language === 'ar' ? '2xl:ml-60 smm:mr-0' : '2xl:ml-60 smm:ml-0'}`}>
          <div className={`w-full h-auto px-3 sm:px-5 flex`}>
            <div
              className={`w-full sm:w-1/2 lg:w-[800px] px-6 bg-gray-500 bg-opacity-20 bg-clip-padding backdrop-filter backdrop-blur-sm text-white z-10 py-4  rounded-lg ${i18n.language === "ar" ? "direction-rtl" : "direction-ltr"
                }`}
            >
              <div className="w-full flex justify-center text-black text-xl mb:2 md:mb-5">
                {t("ASSET TAG INFORMATION")}
              </div>
              <form onSubmit={handleForm} ref={formRef}>
                <div className="mb-6">
                  <label htmlFor="locationtag" className="block mb-2 text-xs font-medium text-black">  {t("Location Tag")}</label>
                  <input
                    placeholder={t("Location Tag")}
                    id="locationtag"
                    name='LocationTag'
                    // value={locationTag}
                    // onChange={handleLocationTagChange}
                    onChange={handleInputChanges}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                </div>


                <div className="mb-6">
                  <label htmlFor="tag" className="block mb-2 text-xs font-medium text-black">{t("TAG")}*</label>
                  <div className='flex'>
                    <div className='w-[80%]'>
                      <input
                        required
                        id='tag'
                        placeholder={t('Tag')}
                        name='TagNumber'
                        // value='hasnain'
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-l focus:ring-blue-500 focus:border-blue-500 block w-[100%] p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        onChange={handleInputChanges}
                      // onChange={handleTagNumberChange}
                      />
                    </div>
                    {/* Tag Button */}
                    <div className='w-[20%] 
                  flex justify-center items-center

                  '>
                      <button
                        onClick={handleTagSerch}
                        type='button'
                        className="bg-[#00006B] text-white font-bold 2xl:py-1.5 xl:py-1.5 lg:py-1.5 md:py-1 py-0.5 
                      2xl:px-5 xl:px-5 lg:px-4 md:px-4 px-2 rounded-r">
                        {t("Search")}
                      </button>
                    </div>
                  </div>
                  {!dataFound && <span style={{ color: 'red', fontSize: '12px' }}>{t("No Data Found!")}</span>}
                </div>

                <div className="mb-6">
                  <label htmlFor="assetlocationtag" className="block mb-2 text-xs font-medium text-black"> {t("Asset Location Details")}*</label>
                  <textarea
                    id="assetlocationtag"

                    name='FullLocationDetails'
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block h-28 w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder={t("Asset Location Details")}
                    value={area}

                    required
                    // onChange={handleAreaChange}
                    onChange={handleInputChanges}
                  />
                </div >

                <div className="mb-6">
                  <label htmlFor="department" className="block mb-2 text-xs font-medium text-black"> {t("Serial No")}.</label>
                  <input
                    placeholder={t("Serial No")}
                    name="sERIALnUMBER"
                    onChange={handleInputChanges}
                    // value={serial}
                    // onChange={handleSerialChange}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                </div>

                <div className='flex flex-wrap <div class="flex justify-between items-center 2xl:gap-10 xl:gap-10 lg:gap-10 md:gap-6 gap-1 w-[100%]'
                >
                  <div className='flex flex-col flex-wrap mb-6 2xl:w-[60%] xl:w-[60%] lg:w-[60%] md:w-[100%] w-[100%]'>
                    {/* <label htmlFor="emp" className="block mb-2 text-xs font-medium text-black">EMPLOYEE ID*</label>
                  <input
                    id="emp"
                    required
                    name="EMPLOYEEID"
                    // value={employee}
                    // onChange={handleEmployeeID}
                    onChange={handleInputChanges}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="EMPLOYEE ID" /> */}
                    <Autocomplete
                      {...defaultProps}
                      id="include-input-in-list"
                      includeInputInList
                      onChange={(event, value) => {
                        if (value) {
                          console.log(`Selected: ${value.EmpName} (${value.EmpID})`);
                          setEmployeeName(value.EmpName)
                          setEmployeeId(value.EmpID)
                        }
                      }}
                      onInputChange={(event, value) => {
                        if (!value) {
                          // perform operation when input is cleared
                          console.log("Input cleared");
                          setEmployeeName('')

                        }
                      }}
                      // on slection of any data 
                      renderInput={(params) => (
                        <TextField {...params} label={t("Enter Employee Name")} variant="standard" />
                      )}
                    />
                  </div>

                  {/* <div className='w-[10%] flex justify-center'>
                  <button type="button" className="bg-[#00006B] text-white font-bold py-2 px-5 rounded-md">
                    List
                  </button>
                </div> */}

                  <div className='flex flex-col flex-wrap mb-6 2xl:w-[30%] xl:w-[30%] lg:w-[30%] md:w-[100%] w-[100%]'>
                    <label htmlFor="phone" className="block mb-2 text-xs font-medium text-black">{t("Phone Extension")}</label>
                    <input
                      name="PhoneExtNo"
                      id="phone"
                      // value={phone}
                      // onChange={handlePhoneChange}
                      onChange={handleInputChanges}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Phone Extension")} />
                  </div>
                </div>

                <div className="mb-6">
                  <label htmlFor="Business" className="block mb-2 text-xs font-medium text-black">{t("Employee ID")}</label>
                  <input
                    type="Business"
                    id="Business"
                    name="EMPLOYEEID"
                    value={employeeId}
                    // onChange={handleBusinessChange}
                    onChange={handleInputChanges}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Employee ID")} />
                </div>

                <div className="mb-6">
                  <label htmlFor="other" className="block mb-2 text-xs font-medium text-black"> {t("Other Tag")}</label>
                  <input
                    name="ATMNumber"
                    onChange={handleInputChanges}
                    type="other"
                    id="other"
                    // value={}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                </div>

                <div className='flex justify-start items-center gap-10'>
                  <div className="flex flex-col flex-wrap mb-6 w-[70%]">
                    <label htmlFor="notes" className="block mb-2 text-xs font-medium text-black">{t("Notes")}</label>
                    <input
                      name='DeliveryNoteNo'
                      onChange={handleInputChanges}
                      type="notes"
                      id="notes"
                      // value={}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                  </div>

                  <div className='flex flex-col mb-6 w-[20%]'>
                    <img
                      src={camera}
                      className='h-10 w-10 mt-5 cursor-pointer'
                      alt=''
                      onClick={handleImageClick}
                    />
                    <input
                      id='fileInput'
                      type='file'
                      onChange={handleFileUpload}
                      style={{ display: 'none' }}
                      className='bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      multiple
                    />
                    <p className='text-black'>max: 4  </p>
                    {/* <p className='text-black'>
                    Selected: {file.length}
                  </p> */}
                  </div>
                </div>

                <div className='flex justify-start items-center gap-10 mb-4'>
                  {/* show image selected by user */}
                  {file.length > 0 && (
                    <div className='flex flex-wrap gap-2'>
                      {file.map((item, index) => (
                        <div key={index}
                          style={{ position: 'relative' }}
                        >
                          <img
                            src={URL.createObjectURL(item)}
                            alt=''
                            className='h-20 w-20 object-cover mb-2'
                          />

                          {/* show cross icon */}
                          <span
                            onClick={() => handleRemoveImage(index)}
                            style={{ position: 'absolute', top: '-21px', right: '-15px' }}
                          >
                            <CloseIcon

                              sx={{ color: '#6B7280', cursor: 'pointer', paddingBottom: '1rem', fontSize: '2.5rem' }}
                            />
                          </span>

                        </div>
                      ))}
                    </div>
                  )}
                </div>


                <div className="mb-6">
                  <label htmlFor="assetcondition" className="block mb-2 text-xs font-medium text-black">{t("Asset Condition")}</label>
                  <select
                    onChange={handleInputChanges}
                    name="aSSETcONDITION"
                    id="assetcondition"
                    // value={assetcondition}
                    // onChange={handleConditionChange}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option>{t("Select AssetCondition")}</option>
                    {assetcondition.map((condition, index) => (
                      <option key={index} value={condition.TblConditionDescription}>
                        {condition.TblConditionDescription}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-6">
                  <label htmlFor="bought" className="block mb-2 text-xs font-medium text-black">{t("Bought")}</label>
                  <select
                    onChange={handleInputChanges}
                    name="Bought"
                    id="bought"
                    // value={assetcondition}
                    // onChange={handleConditionChange}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option>Select Bought</option>
                    {Bought.map(({ TblAssetConditionID, TblConditionCodeBought, TblConditionDescriptionBought }) => (
                      <option key={"bought" + TblConditionCodeBought} value={TblConditionDescriptionBought}>
                        {TblConditionDescriptionBought}
                      </option>
                    ))}
                  </select>
                </div>

                {/* <div className="mb-6">
                <label htmlFor="bought" className="block mb-2 text-xs font-medium text-black">Bought</label>
                <input
                  id='bought'
                  name="Bought"
                  placeholder='Bought'
                  // value={Bought}
                  // onChange={handleBoughtChange}
                  onChange={handleInputChanges}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
              </div> */}

                <div className="mt-4 md:mt-10 flex justify-between w-full text-sm md:text-xl py-2 rounded-md">
                  {/* <Link to='/assets'> */}
                  <button
                    type='button'
                    onClick={() => navigate(-1)} className="bg-[#00006B] text-white font-bold py-3 px-10 rounded-l">
                    {t("Back")}
                  </button>

                  <button type='submit' className="bg-[#00006B] text-white font-bold py-3 px-10 rounded-r">
                    {t("Save")}
                  </button>
                  {/* </Link> */}
                </div>
              </form >
            </div >
          </div >
        </div >
      </div>
    </>
  )
}

export default AssetVerification


const top100Films = [
  { title: 'The Shawshank Redemption', year: 1994 },
  { title: 'The Godfather', year: 1972 },
  { title: 'The Godfather: Part II', year: 1974 },
  { title: 'The Dark Knight', year: 2008 },
  { title: '12 Angry Men', year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: 'Pulp Fiction', year: 1994 },
  {
    title: 'The Lord of the Rings: The Return of the King',
    year: 2003,
  }];